/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetBranchPathParams = NonNullable<operations['getBranch']['parameters']['path']>;

export type GetBranchQueryParams = NonNullable<operations['getBranch']['parameters']['query']>;

export interface Input extends GetBranchPathParams {
  apiVersion?: string;
  query?: GetBranchQueryParams;
}

export async function getBranch(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/code-refs/repositories/{repo}/branches/{branch}', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
